import { LimitsTable } from 'components/table/limits/Table';

const Limits = () => {
    return (
        <>
            <LimitsTable />
        </>
    );
}

export { Limits };